exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".container__1BnA {\n  width: 100%; }\n", "", {"version":3,"sources":["/app/src/ui/properties-panel/forms/src/ui/properties-panel/forms/axis-styles.scss"],"names":[],"mappings":"AAEA;EACE,YAAY,EACb","file":"axis-styles.scss","sourcesContent":["@import \"~nighthawks\";\n\n.container {\n  width: 100%;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "container__1BnA"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]__[hash:base64:4]"}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/ui/properties-panel/forms/axis-styles.scss
// module id = 1475
// module chunks = 0